import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { changeDisable, dateToday, hoursNow, customShortModal, customHalfModal, getPermission, setMaskDecimal, setMaskGeneric, customAdaptativeModal, showMessageError } from '../../../classes/functions';
import './inventory.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog, FaTrash, FaSearch, FaArrowLeft, FaArrowRight, FaChalkboardTeacher, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import baseURL from '../../../baseUrl';
import axios from 'axios';
import download from 'downloadjs';
import InputDate from '../../../components/Inputs/Date/index.js';

export default function Inventory() {
  const { option, id } = useParams();

  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [listStatus, setListStatus] = useState([]);

  const [termSearch, setTermSearch] = useState('');
  const [itensByPage, setItensByPage] = useState(10);
  const [qtdePage, setQtdePage] = useState(10);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [search_status, setSearchStatus] = useState('');
  const [search_warehouse, setSearchWarehouse] = useState('');
  const [search_address, setSearchAddress] = useState('');
  const [search_product, setSearchProduct] = useState('');
  const [search_count, setSearchCount] = useState('');
  const [search_checked, setSearchChecked] = useState('');
  const [label_selected_address, setLabelSelectedAddress] = useState('');

  const [status, setStatus] = useState('');
  const [date, setDate] = useState('');
  const [hour, setHour] = useState('');
  const [description, setDescription] = useState('');
  const [observation, setObservation] = useState('');
  const [inventorying_address, setInventoryingAddress] = useState('');

  const [rows, setRows] = useState([]);
  const [counts, setCounts] = useState([]);
  const [listAddressBindUser, setListAddressBindUser] = useState([]);
  const [listReverseAddress, setListReverseAddress] = useState([]);
  const [listPoductsInventory, setListPoductsInventory] = useState([]);
  const [listInventory, setListInventory] = useState([]);

  const [modalSelectAddress, setModalSelectAddress] = useState(false);
  const [modalReverseAddress, setModalReverseAddress] = useState(false);
  const [modalCountItem, setModalCountItem] = useState(false);
  const [modalLog, setModalLog] = useState(false);
  const [modalLogItem, setModalLogItem] = useState(false);

  const [inventory_warehouse, setInventoryWarehouse] = useState('');
  const [inventory_address, setInventoryAddress] = useState('');
  const [inventory_product_label, setInventoryProductLabel] = useState('');
  const [inventory_product, setInventoryProduct] = useState('');
  const [inventory_quantity, setInventoryQuantity] = useState('');
  const [inventory_observation, setInventoryObservation] = useState('');
  const [inventory_count, setInventoryCount] = useState('');

  const [listDivergenceView, setListDivergenceView] = useState([]);
  const [modalDivergenceCount, setModalDivergenceCount] = useState(false);
  const [modalConfirmPrint, setModalConfirmPrint] = useState(false);
  const [optionPrint, setOptionPrint] = useState('');
  const [printed_format, setPrintedFormat] = useState('');

  const [infos, setInfos] = useState({
    date: ""
  });

  let delay;
  useEffect(() => {
    async function loadInventory() {
      if (id) {
        getOne(id, option);
      } else {
        setStatus('001');
        setInfos((prevState) => ({...prevState, date: dateToday}));
        setHour(hoursNow);
        setCarrying(false);
      }

      getData();
    }

    loadInventory();

  }, []);

  function closeModal() {
    setModalLog(false);
    setModalLogItem(false);
    setModalSelectAddress(false);
    setModalReverseAddress(false);
    setModalDivergenceCount(false);
    setModalConfirmPrint(false);
    setModalCountItem(false);
  }

  function getOne(id, option) {
    api.get("/api/inventory/get?id=" + id)
      .then((response) => {
        setStatus(response.data.row.status);
        setInventoryingAddress(response.data.row.inventorying_address);
        setInfos((prevState) => ({...prevState, date: response.data.log.date}));
        setHour(response.data.log.time);
        setDescription(response.data.row.description);
        setObservation(response.data.row.observation);
        setRows(response.data.rows.dados);
        setCounts(response.data.counts);
        setLastPage(response.data.rows.qtde, qtdePage);
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });

    setView(changeDisable(option));
  }

  async function getData() {
    api.get("/api/inventory/getDataPage")
      .then((response) => {
        setListStatus(response.data.status);

        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function openRemoveItemInventory(idx, item) {
    setCarrying(true);
    api.get("/api/inventory/removeItemInventory?id=" + item.id)
      .then((response) => {
        toast.success("Registro removido com sucesso!");
        getOne(id, option);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function openModalDivergence() {
    setListDivergenceView([]);
    getDataDivergence();
  }

  function confirmPrint(option) {
    setPrintedFormat('');
    setOptionPrint(option);
    setModalDivergenceCount(false);
    setModalConfirmPrint(true);
  }

  function print() {
    if (printed_format !== '') {
      switch (optionPrint) {
        case 'divergence':
          axios.get(
            baseURL + "api/inventory/printDivergence?id=" + id + "&format=" + printed_format,
            {
              responseType: 'blob',
              contentType: 'text/html; charset=UTF-8',
              headers: {
                empresa: localStorage.empresa,
                usuario: localStorage.usuario
              }
            }
          ).then((response) => {
            const content = response.headers['content-type'];
            if (printed_format == 'pdf') {
              download(response.data, 'relatorio-divergencia.pdf', content);
            } else if (printed_format == 'excel') {
              download(response.data, 'relatorio-divergencia.xlsx', content);
            }
            setCarrying(false);
          }).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
          break;

        case 'selected_list':
          let data = {
            data: {
              id: id,
              warehouse: search_warehouse,
              address: search_address,
              product: search_product,
              termSearch: termSearch,
              status: search_status,
              count: search_count,
              checked: search_checked,
              page: page,
              qtdePage: qtdePage,
            }
          };
          axios.post(
            baseURL + "api/inventory/printListItems?format=" + printed_format, data, 
            {
              responseType: 'blob',
              contentType: 'text/html; charset=UTF-8',
              headers: {
                empresa: localStorage.empresa,
                usuario: localStorage.usuario
              }
            }
          ).then((response) => {
            const content = response.headers['content-type'];
            if (printed_format == 'pdf') {
              download(response.data, 'relatorio-divergencia.pdf', content);
            } else if (printed_format == 'excel') {
              download(response.data, 'relatorio-divergencia.xlsx', content);
            }
            setCarrying(false);
          }).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
          break;

        default:
          toast.error('Opção não selecionada!');
          break;
      }
    } else {
      toast.error('Formato não selecionado!');
    }
  }

  function getDataDivergence() {
    setCarrying(true);
    api.get("/api/inventory/getDivergence?id=" + id)
      .then((response) => {
        setListDivergenceView(response.data);
        setCarrying(false);
        setModalDivergenceCount(true);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function openModalReverseCount() {
    setCarrying(true);
    api.get("/api/inventory/getAddressToReverse?id=" + id)
      .then((response) => {
        setModalReverseAddress(true);
        setListReverseAddress(response.data);
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function openModalBindAddress() {
    setCarrying(true);
    api.get("/api/inventory/getAddressToInventory?id=" + id)
      .then((response) => {
        setModalSelectAddress(true);
        setListAddressBindUser(response.data);
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function setReverseAddress(item) {
    setCarrying(true);
    let data = {
      data: {
        id_inventory: id,
        id_warehouse: item.id_warehouse,
        id_address: item.id_address,
        count: item.count_number,
      }
    };

    api.post("/api/inventory/setReverseAddress", data)
      .then((response) => {
        toast.success("Contagem estornada!");

        setModalReverseAddress(false);
        getOne(id, option);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function setBindUser(item, option = 'T') {
    setCarrying(true);
    let data = {
      data: {
        id_inventory: id,
        id_warehouse: item.id_warehouse,
        id_address: item.id_address,
        count: item.count_number,
        connect: option
      }
    };

    api.post("/api/inventory/setBindUser", data)
      .then((response) => {
        setModalSelectAddress(false);
        setModalCountItem(true);
        setLabelSelectedAddress(item.warehouse + ' - ' + item.address);
        setInventoryWarehouse(item.id_warehouse);
        setInventoryCount(item.count_number);
        setInventoryAddress(item.id_address);
        setInventoryingAddress({
          address: item.address,
          count: item.count_number,
          id_address: item.id_address,
          id_warehouse: item.id_warehouse,
          warehouse: item.warehouse,
        });
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function searchProduct(e) {
    api.get("/api/products/getSearchProduct?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListPoductsInventory(response.data.list);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });

    setInventoryProductLabel(e.target.value);
  }

  function selectProduct(item) {
    setInventoryProduct(item.id);
    setInventoryProductLabel(item.codigo_produto + ' - ' + item.descricao);
    setListPoductsInventory([]);
  }

  function confirmItem() {
    let aux = listInventory;
    aux.push({
      inventory: id,
      date: dateToday,
      hour: hoursNow,
      warehouse: inventory_warehouse,
      address: inventory_address,
      product: inventory_product,
      quantity: inventory_quantity,
      observation: inventory_observation,
      count: inventory_count
    });

    setListInventory(aux);

    setInventoryProductLabel('');
    setInventoryProduct('');
    setInventoryQuantity('');
    setInventoryObservation('');
  }

  function cancelAddress() {
    setCarrying(true);
    let data = {
      data: {
        id_inventory: id,
        id_warehouse: inventory_warehouse,
        id_address: inventory_address,
        count: inventory_count,
        connect: 'F'
      }
    };

    api.post("/api/inventory/setBindUser", data)
      .then((response) => {
        toast.success('Contagem do endereço concelada.');
        setModalSelectAddress(false);
        setModalCountItem(false);
        setInventoryWarehouse('');
        setInventoryAddress('');
        setInventoryCount('');
        setInventoryingAddress('');
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function confirmAddress() {
    setCarrying(true);

    api.post("/api/inventory/postItemInventory", { list: listInventory })
      .then((response) => {
        toast.success('Inventário registrado com sucesso.');
        setModalSelectAddress(false);
        setModalCountItem(false);
        setInventoryWarehouse('');
        setInventoryAddress('');
        setInventoryCount('');
        
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });

  }

  function search(qtdeItens = qtdePage, term = termSearch, status = search_status, warehouse = search_warehouse, address = search_address, product = search_product, count = search_count, checked = search_checked) {
    clearTimeout(delay);

    delay = setTimeout(() => {
      setSearchWarehouse(warehouse);
      setSearchAddress(address);
      setSearchProduct(product);
      setTermSearch(term);
      setSearchCount(count);
      setSearchStatus(status);
      setSearchChecked(checked);
      setQtdePage(qtdeItens);

      setPage(1);

      let data = {
        data: {
          id: id,
          warehouse: warehouse,
          address: address,
          product: product,
          termSearch: term,
          status: status,
          count: count,
          checked: checked,
          page: page,
          qtdePage: qtdeItens,
        }
      };

      api.post("/api/inventory/getSearchRows", data)
        .then((response) => {
          setRows(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdeItens);

          setCarrying(false);
        }).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }, 750);
  }

  function nextPage() {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          id: id,
          warehouse: search_warehouse,
          address: search_address,
          product: search_product,
          termSearch: termSearch,
          status: status,
          count: search_count,
          checked: search_checked,
          page: page + 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearchRows", data)
        .then((response) => {
          setRows(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(page + 1);
          setQtdePage(qtdePage);
        }
        ).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }
  }

  function lastPage() {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          id: id,
          warehouse: search_warehouse,
          address: search_address,
          product: search_product,
          termSearch: termSearch,
          status: status,
          count: search_count,
          checked: search_checked,
          page: limitPage,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearchRows", data)
        .then((response) => {
          setRows(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(limitPage);
          setQtdePage(qtdePage);
        }).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }
  }

  function firstPage() {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          id: id,
          warehouse: search_warehouse,
          address: search_address,
          product: search_product,
          termSearch: termSearch,
          status: status,
          count: search_count,
          checked: search_checked,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearchRows", data)
        .then((response) => {
          setRows(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(1);
          setQtdePage(qtdePage);
        }).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }
  }

  function previewPage() {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          id: id,
          warehouse: search_warehouse,
          address: search_address,
          product: search_product,
          termSearch: termSearch,
          status: status,
          count: search_count,
          checked: search_checked,
          page: page - 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearchRows", data)
        .then((response) => {
          setRows(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(page - 1);
          setQtdePage(qtdePage);
        }).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Inventário">
          <Link to="/inventory">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Inventário</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Descrição</label>&nbsp;<label className="required">*</label><br />
                  <input type="text" placeholder="Descrição" value={description} onChange={(e) => setDescription(e.target.value)} maxLength="200" disabled={id} />
                </div>

                <div className="formDiv">
                  <label>Status</label><br />
                  <select value={status} onChange={(e) => setStatus(e.target.value)} disabled={true}>
                    <option value="">Selecione</option>
                    {listStatus.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Data Criação</label><br />
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="date" disabled />
                </div>

                <div className="formDiv">
                  <label>Hora Criação</label><br />
                  <input type="text" placeholder="##:##:##" value={hour} onChange={(e) => setHour(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true} />
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Observacao</label>&nbsp;<label className="required">*</label><br />
                  <input type="text" placeholder="Observação" value={observation} onChange={(e) => setObservation(e.target.value)} maxLength="200" disabled={id} />
                </div>
              </div>
            </div>
            <br />

            <div className="divGroup">
              <div className="formDiv">
                {inventorying_address && <button type="button" className="buttonTab" onClick={() => { setModalCountItem(true); setLabelSelectedAddress(inventorying_address.warehouse + ' - ' + inventorying_address.address); setInventoryAddress(inventorying_address.id_address); setInventoryWarehouse(inventorying_address.id_warehouse); setInventoryCount(inventorying_address.count) }} disabled={view}>Continuar Endereço</button>}
                {!inventorying_address && <button type="button" className="buttonTab" onClick={openModalBindAddress} disabled={view}>Selecionar Endereço</button>}
                {id && getPermission('OPERACOES - INVENTARIO - ESTORNAR CONFERENCIA') && <button type="button" className="buttonTab" onClick={openModalReverseCount} disabled={view}>Estornar Contagem</button>}
                {id && <button type="button" className="buttonTab" onClick={openModalDivergence} disabled={view}>Consultar Divergência</button>}
              </div>
            </div>

            <div className="divGroup">
              <div className="formDivList">
                <div className="containerGroupData">
                  <button type="button" onClick={() => confirmPrint('selected_list')} className="buttonPrint">Imprimir Seleção</button>
                  <select className='selectQtdeItens' value={itensByPage} onChange={(e) => { setItensByPage(e.target.value); search(e.target.value, termSearch, search_status); }}>
                    <option value="10">Itens por página</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
                  <input className="inputSearch" type="text" onChange={(e) => { search(itensByPage, e.target.value, search_status) }} placeholder="Pesquisar" />
                  <FaSearch className="iconSearch" style={{ color: '#001675' }} size={16} />
                  <h2>Itens&nbsp;<label className="required">*</label></h2>
                  <hr></hr>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col" className='collumOption'>
                          <div className="formDiv">
                            <select value={search_checked} onChange={(e) => { setSearchChecked(e.target.value); search(qtdePage, termSearch, search_status, search_warehouse, search_address, search_product, search_count, e.target.value); }}
                              disabled={view}>
                              <option value="">Inventariado</option>
                              <option value="S">Sim</option>
                              <option value="N">Não</option>
                            </select>
                          </div>
                        </th>
                        <th scope="col" className='collumOption'>
                          <div className="formDiv">
                            <input type="text" placeholder="Contagem" value={search_count} onChange={(e) => { setSearchCount(e.target.value); search(qtdePage, termSearch, search_status, search_warehouse, search_address, search_product, e.target.value, search_checked); }} maxLength="20" />
                          </div>
                        </th>
                        {/* <th scope="col">
                          <input type="checkbox" onChange={changeItem} />
                        </th> */}
                        <th scope="col">
                          <div className="formDiv">
                            <input type="text" placeholder="Armazém" value={search_warehouse} onChange={(e) => { setSearchWarehouse(e.target.value); search(qtdePage, termSearch, search_status, e.target.value, search_address, search_product, search_count, search_checked); }} maxLength="20" />
                          </div>
                        </th>
                        <th scope="col">
                          <div className="formDiv">
                            <input type="text" placeholder="Endereço" value={search_address} onChange={(e) => { setSearchAddress(e.target.value); search(qtdePage, termSearch, search_status, search_warehouse, e.target.value, search_product, search_count, search_checked); }} maxLength="20" />
                          </div>
                        </th>
                        <th scope="col">
                          <div className="formDiv">
                            <input type="text" placeholder="Produto" value={search_product} onChange={(e) => { setSearchProduct(e.target.value); search(qtdePage, termSearch, search_status, search_warehouse, search_address, e.target.value, search_count, search_checked); }} maxLength="20" />
                          </div>
                        </th>
                        <th scope="col">Quantidade Estoque</th>
                        <th scope="col">Quantidade Inventariada</th>
                        <th scope="col">Observação</th>
                        <th scope="col" className='collumOption'>Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.checked}</td>
                            <td>{item.count_number}</td>
                            {/* <td data-label="#">
                              <input type="checkbox" checked={item.checked} value={item.id} onChange={changeItem} />
                            </td> */}
                            <td>{item.warehouse}</td>
                            <td>{item.address}</td>
                            <td>{item.product}</td>
                            <td>{item.quantity}</td>
                            <td>{item.quantity_inventoried}</td>
                            <td>{item.observation}</td>
                            <td>
                              <Link className="action" onClick={() => openRemoveItemInventory(index, item)}>
                                <FaTrash color="#000" size={17} />
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                      {rows.length == 0 && <tr>
                        <td colSpan={9}><label className='required'>Nenhum registro encontrado!</label></td>
                      </tr>}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

            <div className="divGroup">
              <div className="formDivList">
                <div className="formDiv">
                  <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
                  <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
                  <div className="divLabelPagination">
                    <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
                  </div>
                  <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
                  <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>}
      <Modal
        isOpen={modalSelectAddress}
        onRequestClose={closeModal}
        style={customHalfModal}
        contentLabel="Endereços"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th className='collumOption'>#</th>
                  <th>Armazém</th>
                  <th>Endereço</th>
                  <th>Contagem</th>
                  <th className='collumOption'>Opção</th>
                </tr>
              </thead>
              <tbody>
                {listAddressBindUser && listAddressBindUser.length > 0 && listAddressBindUser.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td>{item.warehouse}</td>
                      <td>{item.address}</td>
                      <td>{item.count_number}</td>
                      <td>
                        <ReactTooltip />
                        <FaChalkboardTeacher className="iconAction" color="#000" size={17} onClick={() => setBindUser(item)} data-tip="Selecionar" />
                      </td>
                    </tr>
                  )
                })}
                {listAddressBindUser.length == 0 &&
                  <tr>
                    <td colSpan={5}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalReverseAddress}
        onRequestClose={closeModal}
        style={customHalfModal}
        contentLabel="Endereços"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th className='collumOption'>#</th>
                  <th>Armazém</th>
                  <th>Endereço</th>
                  <th>Contagem</th>
                  <th className='collumOption'>Opção</th>
                </tr>
              </thead>
              <tbody>
                {listReverseAddress && listReverseAddress.length > 0 && listReverseAddress.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td>{item.warehouse}</td>
                      <td>{item.address}</td>
                      <td>{item.count_number}</td>
                      <td>
                        <ReactTooltip />
                        <FaArrowLeft className="iconAction" color="#000" size={17} onClick={() => setReverseAddress(item)} data-tip="Selecionar" />
                      </td>
                    </tr>
                  )
                })}
                {listReverseAddress.length == 0 &&
                  <tr>
                    <td colSpan={5}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalCountItem}
        onRequestClose={closeModal}
        style={customShortModal}
        contentLabel="Itens"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">
            <div className="formDiv">
              <label>{label_selected_address}</label>
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <label>Produto</label>&nbsp;<label className="required">*</label><br />
              <input type="text" placeholder="Produto" value={inventory_product_label} onChange={searchProduct} maxLength="150" disabled={view} />
              <ul className="dropdown-menu" id="productsDatalist">
                {listPoductsInventory.map((item, index) => (
                  <li key={index} onClick={() => selectProduct(item)}>
                    <a>{item.codigo_produto + ' - ' + item.descricao}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <label>Quantidade</label>&nbsp;<label className="required">*</label><br />
              <input type="text" placeholder="Quantidade" value={inventory_quantity} onChange={(e) => setInventoryQuantity(setMaskDecimal(e.target.value, 4))} maxLength="30" disabled={view} />
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <label>Observação</label><br />
              <input type="text" placeholder="Observação" value={inventory_observation} onChange={(e) => setInventoryObservation(e.target.value)} maxLength="30" disabled={view} />
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <button type="button" className="buttonSubmit inputSm marginRight" onClick={() => confirmItem(false)} disabled={view}>Confirmar</button>
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <button type="button" className="buttonSubmit inputSm marginRight" onClick={() => confirmAddress()} disabled={view}>Finalizar</button>
              <button type="button" className="buttonCancel inputSm marginRight" onClick={() => cancelAddress()} disabled={view}>Cancelar</button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalConfirmPrint}
        onRequestClose={closeModal}
        style={customShortModal}
        contentLabel="Confirmação Impressão"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">
            <div className="formDiv">
              <label>Confirmar Impressão -&nbsp;</label>
              {optionPrint == 'divergence' && <label>Relatório de Divergência</label>}
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <label>Formato</label>&nbsp;<label className="required">*</label><br />
              <select value={printed_format} onChange={(e) => setPrintedFormat(e.target.value)} disabled={view}>
                <option>Selecione</option>
                <option value="pdf">PDF</option>
                <option value="excel">Excel</option>
              </select>
            </div>
          </div>

          <div className="divGroup">
            <div className="formDiv">
              <button type="button" className="buttonSubmit inputSm marginRight" onClick={() => print()} disabled={view}>Imprimir</button>
              <button type="button" className="buttonCancel inputSm pullRight" onClick={closeModal} disabled={view}>Cancelar</button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalDivergenceCount}
        onRequestClose={closeModal}
        style={customAdaptativeModal}
        contentLabel="Verificação de Divergência"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">

          </div>
          <div className="divGroup">
            <div className="formDiv">
              <table>
                <thead>
                  <tr>
                    <th className='collumIndex'>#</th>
                    <th className='collumMedium'>Armazém</th>
                    <th className='collumMedium'>Endereço</th>
                    <th>Produto</th>
                    {counts.map((count) => (
                      <th className='collumShort'>Contagem {count.count}</th>
                    ))}
                    <th className='collumShort'>Divergência</th>
                  </tr>
                </thead>
                <tbody>
                  {listDivergenceView && listDivergenceView.length > 0 && listDivergenceView.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.warehouse}</td>
                        <td>{item.address}</td>
                        <td>{item.code_product} - {item.product}</td>
                        {counts.map((count) => (
                          <td>{item[count.field]}</td>
                        ))}
                        <td>
                          {/* {item.difference} */}
                          {item.difference === 'Não' && <FaThumbsUp className='icon_notdivergence'></FaThumbsUp>}
                          {item.difference === 'Sim' && <FaThumbsDown className='icon_divergence'></FaThumbsDown>}
                        </td>
                      </tr>
                    )
                  })}
                  {listDivergenceView.length == 0 &&
                    <tr>
                      <td colSpan={5}><label className='required'>Nenhum registro encontrado!</label></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="divGroup">
            <div className="formDiv">
              <button type="button" className="buttonSubmit" onClick={() => confirmPrint('divergence')} disabled={view}>Imprimir</button>
              <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}